const API_ROOT = 'https://www.googleapis.com/youtube/v3';

export async function fetchWithToken(path, token) {
  const response = await fetch(`${API_ROOT}${path}`, {
    headers: { Authorization: `Bearer ${token}` }
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.error?.message || 'YouTube API error');
  }

  return response.json();
}

export async function fetchWithApiKey(path, apiKey) {
  const joiner = path.includes('?') ? '&' : '?';
  const response = await fetch(`${API_ROOT}${path}${joiner}key=${apiKey}`);

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.error?.message || 'YouTube API error');
  }

  return response.json();
}

export async function fetchSubscriptions(token) {
  return fetchWithToken(`/subscriptions?part=snippet,contentDetails&mine=true&maxResults=50`, token);
}

export async function fetchChannelDetails(token, channelId) {
  return fetchWithToken(`/channels?part=snippet,statistics,contentDetails&id=${channelId}`, token);
}

export async function fetchChannelVideos(token, playlistId) {
  return fetchWithToken(`/playlistItems?part=snippet,contentDetails&playlistId=${playlistId}&maxResults=50`, token);
}

export async function fetchChannelDetailsWithKey(apiKey, channelId) {
  return fetchWithApiKey(`/channels?part=snippet,statistics,contentDetails&id=${channelId}`, apiKey);
}

export async function fetchChannelVideosWithKey(apiKey, playlistId) {
  return fetchWithApiKey(`/playlistItems?part=snippet,contentDetails&playlistId=${playlistId}&maxResults=50`, apiKey);
}
